import { render } from "./index.vue?vue&type=template&id=41812a9d&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=41812a9d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-41812a9d"

export default script